import { terraContract } from '@terra/shared-authorization';
import { z } from 'zod/v3';
import { COCKPIT_SQL_WORKSHEET_PERMISSIONS } from './cockpit-permissions';
import {
  ExecuteSqlWorksheetBodySchema,
  GenerateSqlWorksheetBodySchema,
  GenerateSqlWorksheetResultSchema,
  SqlWorksheetColumnListSchema,
  SqlWorksheetDatabaseListSchema,
  SqlWorksheetIdentifierSchema,
  SqlWorksheetResultSchema,
  SqlWorksheetSchemaListSchema,
  SqlWorksheetTableListSchema,
} from './sql-worksheet.schemas';

export const cockpitSqlWorksheetRoutes = {
  executeSqlWorksheetStatement: terraContract
    .meta({ permissions: [...COCKPIT_SQL_WORKSHEET_PERMISSIONS] })
    .route({
      method: 'POST',
      path: '/sql-worksheet/execute',
      summary: 'Execute a read-only PostgreSQL statement',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: ExecuteSqlWorksheetBodySchema }))
    .output(SqlWorksheetResultSchema),

  generateSqlWorksheetStatement: terraContract
    .meta({ permissions: [...COCKPIT_SQL_WORKSHEET_PERMISSIONS] })
    .route({
      method: 'POST',
      path: '/sql-worksheet/generate',
      summary: 'Draft one read-only PostgreSQL statement',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: GenerateSqlWorksheetBodySchema }))
    .output(GenerateSqlWorksheetResultSchema),

  listSqlWorksheetDatabases: terraContract
    .meta({ permissions: [...COCKPIT_SQL_WORKSHEET_PERMISSIONS] })
    .route({
      method: 'GET',
      path: '/sql-worksheet/databases',
      summary: 'List databases available to the SQL worksheet',
      inputStructure: 'detailed',
    })
    .input(z.object({}))
    .output(SqlWorksheetDatabaseListSchema),

  listSqlWorksheetSchemas: terraContract
    .meta({ permissions: [...COCKPIT_SQL_WORKSHEET_PERMISSIONS] })
    .route({
      method: 'GET',
      path: '/sql-worksheet/databases/{database}/schemas',
      summary: 'List schemas in a SQL worksheet database',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ database: SqlWorksheetIdentifierSchema }),
      }),
    )
    .output(SqlWorksheetSchemaListSchema),

  listSqlWorksheetTables: terraContract
    .meta({ permissions: [...COCKPIT_SQL_WORKSHEET_PERMISSIONS] })
    .route({
      method: 'GET',
      path: '/sql-worksheet/databases/{database}/schemas/{schema}/tables',
      summary: 'List tables in a SQL worksheet schema',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({
          database: SqlWorksheetIdentifierSchema,
          schema: SqlWorksheetIdentifierSchema,
        }),
      }),
    )
    .output(SqlWorksheetTableListSchema),

  listSqlWorksheetColumns: terraContract
    .meta({ permissions: [...COCKPIT_SQL_WORKSHEET_PERMISSIONS] })
    .route({
      method: 'GET',
      path: '/sql-worksheet/databases/{database}/schemas/{schema}/tables/{table}/columns',
      summary: 'List columns in a SQL worksheet table',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({
          database: SqlWorksheetIdentifierSchema,
          schema: SqlWorksheetIdentifierSchema,
          table: SqlWorksheetIdentifierSchema,
        }),
      }),
    )
    .output(SqlWorksheetColumnListSchema),
};
